import React from 'react'
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PrivateRoute from '../Utils/privateRoute';
import Layout from '../Layout';
import Login from '../Components/AuthComponent/SignInProcess/login';
import Register from '../Components/AuthComponent/SignInProcess/register';
import SignupPayment from '../Components/AuthComponent/SignInProcess/SignupPayment';
import SignupSelectPlan from '../Components/AuthComponent/SignInProcess/SignupSelectPlan';
import SelectRole from '../Components/AuthComponent/SignInProcess/selectSignUpRole';
import ForgotPassword from '../Components/AuthComponent/SignInProcess/forgotPassword';
import ResetPassword from '../Components/AuthComponent/SignInProcess/resetPassword';
import Terms from '../Components/AuthComponent/SignInProcess/Terms';
import PrivacyPolicy from '../Components/AuthComponent/SignInProcess/PrivacyPolicy';
import Dashboard from '../Components/AdminComponents/dashboard';
import HeadsOfLineColors from '../Components/AdminComponents/DashboardComponents/HeadsOfLineColors';
import TotalFamilyMembers from '../Components/AdminComponents/DashboardComponents/TotalFamilyMembers';
import TotalMaleFemale from '../Components/AdminComponents/DashboardComponents/TotalMaleFemale';
import BirthdaysThisWeek from '../Components/AdminComponents/DashboardComponents/BirthdaysThisWeek';
import AnniversariesThisWeek from '../Components/AdminComponents/DashboardComponents/AnniversariesThisWeek';
import MilestoneWeddingAnniversaries from '../Components/AdminComponents/DashboardComponents/MilestoneWeddingAnniversaries';
import FamilyHeadsGrandCount from '../Components/AdminComponents/DashboardComponents/FamilyHeadsGrandCount';
import BirthdaysByFamilyLines from '../Components/AdminComponents/DashboardComponents/BirthdaysByFamilyLines';
import BirthByDay from '../Components/AdminComponents/DashboardComponents/BirthByDay';
import MemorialsThisWeek from '../Components/AdminComponents/DashboardComponents/MemorialsThisWeek';
import AgesMilestone from '../Components/AdminComponents/DashboardComponents/AgesMilestone';
import MonthlyAgesMilestone from '../Components/AdminComponents/DashboardComponents/MonthlyAgesMilestone';
import AgeByGroup from '../Components/AdminComponents/DashboardComponents/AgeByGroup';
import MultiBirthsByGeneration from '../Components/AdminComponents/DashboardComponents/MultiBirthsByGeneration';
import DescInAgeGeneration from '../Components/AdminComponents/DashboardComponents/DescInAgeGeneration';
import InLawBirthdays from '../Components/AdminComponents/DashboardComponents/InLawBirthdays';
import DescParentChildren from '../Components/AdminComponents/DashboardComponents/DescParentChildren';
import DescByState from '../Components/AdminComponents/DashboardComponents/DescByState';
import DescendantAgeGroup from '../Components/AdminComponents/DashboardComponents/DescendantAgeGroup';
import FamilyMembersSinceYear from '../Components/AdminComponents/DashboardComponents/FamilyMembersSinceYear';
import FamilyTree from '../Components/AdminComponents/familyTree';
import Message from '../Components/AdminComponents/Messages/Message'
import Reports from '../Components/AdminComponents/reports';
import PhoneNumberReport from '../Components/AdminComponents/PhoneNumberReport/PhoneNumberReport';
import SettingsLayout from '../Components/AdminComponents/Settings/SettingsLayout'
import MyProfile from '../Components/AdminComponents/Settings/MyProfile'
import Notification from '../Components/AdminComponents/Settings/Notification'
import ChangePassword from '../Components/AdminComponents/Settings/ChangePassword'
import SubscriptionManagement from '../Components/AdminComponents/Settings/SubscriptionManagement'
import Subscription from '../Components/AdminComponents/subsciption';
import Meditation from '../Components/AdminComponents/meditation';
import Support from '../Components/AdminComponents/support';
import AdminInstruction from '../Components/AdminComponents/AdminInstruction';
import Faq from '../Components/AdminComponents/Faq';
import UserManagement from '../Components/AdminComponents/dashboard';
import Event from '../Components/AdminComponents/Events/Event';
import EventDetails from '../Components/AdminComponents/Events/EventDetails';
import AllTreeEvents from '../Components/AdminComponents/Events/AllTreeEvents';
import FamilyNews from '../Components/AdminComponents/FamilyNews/FamilyNews';
import FamilyHistory from '../Components/AdminComponents/FamilyHistory/FamilyHistory';
import Landing from '../Components/HomeComponent/landing';
import SuperAdminRoute from '../Components/SuperAdminComponents/SuperAdminRoute';
import SuperAdminLayout from '../Components/SuperAdminComponents/Layout';
import SuperAdminUserManagement from '../Components/SuperAdminComponents/Pages/UserManagement';
import SuperAdminAdminManagement from '../Components/SuperAdminComponents/Pages/AdminManagement';
import SuperAdminSubscriptionManagement from '../Components/SuperAdminComponents/Pages/SubscriptionManagement';
import SuperAdminSettingsLayout from '../Components/SuperAdminComponents/Settings/SettingsLayout';


export default function Routing() {
  return (
    <>
      <Routes >
      <Route path="" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/register/payment" element={<SignupPayment />} />
      <Route path="/register/plans" element={<SignupSelectPlan />} />
      <Route path="/select-role" element={<SelectRole />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      
        {/* Routes for admin login with user header starts */}
        <Route path="/" element={<PrivateRoute component={Layout} />}>
          <Route path="dashboard" element={<PrivateRoute component={Dashboard} />} />
          <Route path="dashboard/heads-of-line" element={<PrivateRoute component={HeadsOfLineColors} />} />
          <Route path="dashboard/total-family-members" element={<PrivateRoute component={TotalFamilyMembers} />} />
          <Route path="dashboard/total-male-female" element={<PrivateRoute component={TotalMaleFemale} />} />
          <Route path="dashboard/birthdays-this-month" element={<PrivateRoute component={BirthdaysThisWeek} />} />
          <Route path="dashboard/anniversaries-this-month" element={<PrivateRoute component={AnniversariesThisWeek} />} />
          <Route path="dashboard/milestone-wedding-anniversaries" element={<PrivateRoute component={MilestoneWeddingAnniversaries} />} />
          <Route path="dashboard/family-heads" element={<PrivateRoute component={FamilyHeadsGrandCount} />} />
          <Route path="dashboard/birthdays-by-family-lines" element={<PrivateRoute component={BirthdaysByFamilyLines} />} />
          <Route path="dashboard/birth-by-day" element={<PrivateRoute component={BirthByDay} />} />
          <Route path="dashboard/memorials-this-month" element={<PrivateRoute component={MemorialsThisWeek} />} />
          <Route path="dashboard/ages-milestone" element={<PrivateRoute component={AgesMilestone} />} />
          <Route path="dashboard/monthly-ages-milestone" element={<PrivateRoute component={MonthlyAgesMilestone} />} />
          <Route path="dashboard/age-by-group" element={<PrivateRoute component={AgeByGroup} />} />
          <Route path="dashboard/multi-births-by-generation" element={<PrivateRoute component={MultiBirthsByGeneration} />} />
          <Route path="dashboard/desc-in-age-generation" element={<PrivateRoute component={DescInAgeGeneration} />} />
          <Route path="dashboard/in-law-birthdays" element={<PrivateRoute component={InLawBirthdays} />} />
          <Route path="dashboard/desc-parent-children" element={<PrivateRoute component={DescParentChildren} />} />
          <Route path="dashboard/desc-by-state" element={<PrivateRoute component={DescByState} />} />
          <Route path="dashboard/descendant-age-group" element={<PrivateRoute component={DescendantAgeGroup} />} />
          <Route path="dashboard/family-members-since-2000" element={<PrivateRoute component={FamilyMembersSinceYear} />} />
          <Route path="user/dashboard" element={<PrivateRoute component={Dashboard} />} />
          <Route path="notary/dashboard" element={<PrivateRoute component={Dashboard} />} />
          <Route path="family-tree" element={<PrivateRoute component={FamilyTree} />} />
          <Route path="family-news" element={<PrivateRoute component={FamilyNews} />} />
          <Route path="family-history" element={<PrivateRoute component={FamilyHistory} />} />
          <Route path="messages" element={<PrivateRoute component={Message} />} />
          {/* Redirect /events/tab=received (path) to /events?tab=received (query) so Event component renders and tab is set */}
          <Route path="events/tab=received" element={<Navigate to="/events?tab=received" replace />} />
          <Route path="events/tab=archived" element={<Navigate to="/events?tab=archived" replace />} />
          <Route path="events/tab=myInvitations" element={<Navigate to="/events?tab=myInvitations" replace />} />
          <Route path="events" element={<PrivateRoute component={Event}/>} />
          <Route path="events/:id" element={<PrivateRoute component={EventDetails}/>}/>
          <Route path="events/all-tree-events" element={<PrivateRoute component={AllTreeEvents} />}/>
          <Route path="reports" element={<PrivateRoute component={Reports} />} />
          <Route path="reports/phone-numbers" element={<PrivateRoute component={PhoneNumberReport} />} />
          <Route path="admin-instruction" element={<PrivateRoute component={AdminInstruction} />} />
          <Route path="faq" element={<PrivateRoute component={Faq} />} />
          <Route path="settings" element={<PrivateRoute component={SettingsLayout} />}>
            <Route index element={<Navigate to="/settings/password" replace />} />
            <Route path="profile" element={<MyProfile />} />
            <Route path="notifications" element={<Notification />} />
            <Route path="password" element={<ChangePassword />} />
            <Route path="subscription" element={<SubscriptionManagement />} />
          </Route>
          <Route path="user-management" element={<PrivateRoute component={UserManagement} />} />
          <Route path="subscription" element={<PrivateRoute component={Subscription} />} />
          <Route path="meditaion" element={<PrivateRoute component={Meditation} />} />
          <Route path="support" element={<PrivateRoute component={Support} />} />
        </Route>
        {/* Routes for admin login with user header ends */}

        {/* Super Admin routes */}
        <Route path="/super-admin" element={<SuperAdminRoute component={SuperAdminLayout} />}>
          <Route index element={<Navigate to="/super-admin/user-management" replace />} />
          <Route path="user-management" element={<SuperAdminRoute component={SuperAdminUserManagement} />} />
          <Route path="admin-management" element={<SuperAdminRoute component={SuperAdminAdminManagement} />} />
          <Route path="subscription-management" element={<SuperAdminRoute component={SuperAdminSubscriptionManagement} />} />
          <Route path="settings" element={<SuperAdminRoute component={SuperAdminSettingsLayout} />}>
            <Route index element={<Navigate to="/super-admin/settings/password" replace />} />
            <Route path="password" element={<ChangePassword />} />
          </Route>
        </Route>
      </Routes>
      <ToastContainer />
      </>
  );
}
